import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api';
import { useAuth } from '../context/AuthContext';
import AuthShell from '../components/AuthShell';

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const res = await api.post('/auth/login', formData);
      login(res.data.token, res.data.user);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    } finally { setLoading(false); }
  };

  return (
    <AuthShell>
      {/* Headline */}
      <div style={{ marginBottom: 32 }}>
        <h1 style={{
          fontFamily: 'var(--tandm-font-display)',
          fontSize: 32, fontWeight: 500, color: 'var(--tandm-on-dark)',
          letterSpacing: '-0.03em', margin: '0 0 6px', lineHeight: 1.1,
        }}>
          Welcome<br />
          <span style={{
            background: 'var(--tandm-gradient-text)',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
          }}>back.</span>
        </h1>
        <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', margin: 0 }}>
          Sign in to access your internships
        </p>
      </div>

      {/* Error */}
      {error && (
        <div style={{
          background: 'rgba(185,28,28,0.14)', border: '1px solid rgba(252,165,165,0.3)',
          color: '#FCA5A5', borderRadius: 10, padding: '10px 14px',
          marginBottom: 20, fontSize: 13, display: 'flex', alignItems: 'center', gap: 8,
        }}>
          <svg width="13" height="13" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {error}
        </div>
      )}

      {/* Form */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
        <div>
          <label className="lf-label">Email</label>
          <input
            name="email" type="email" required
            value={formData.email} onChange={handleChange}
            className="lf-input" placeholder="jane@university.ac.uk"
          />
        </div>

        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
            <label className="lf-label" style={{ margin: 0 }}>Password</label>
            <Link to="/forgot-password" className="lf-link" style={{ fontSize: 11, opacity: 0.7 }}>
              Forgot password?
            </Link>
          </div>
          <div className="pw-wrap">
            <input
              name="password" type={showPassword ? 'text' : 'password'} required
              value={formData.password} onChange={handleChange}
              className="lf-input" placeholder="Your password"
              style={{ paddingRight: 44 }}
            />
            <button type="button" className="pw-btn" onClick={() => setShowPassword(s => !s)}>
              {showPassword
                ? <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" /></svg>
                : <svg width="15" height="15" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /><path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" /></svg>
              }
            </button>
          </div>
        </div>

        <button onClick={handleSubmit} disabled={loading} className="lf-btn" style={{ marginTop: 4 }}>
          {loading
            ? <><div className="lf-spinner" />Signing in...</>
            : <>Sign in <svg width="14" height="14" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2.5}><path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" /></svg></>
          }
        </button>
      </div>

      {/* Footer */}
      <p style={{ textAlign: 'center', fontSize: 13, color: 'rgba(255,255,255,0.35)', marginTop: 24, marginBottom: 0 }}>
        No account?{' '}
        <Link to="/signup" className="lf-link">Sign up</Link>
      </p>
    </AuthShell>
  );
}
